import { render } from "./BuildSummaryCard.vue?vue&type=template&id=3bfc2eb8"
import script from "./BuildSummaryCard.vue?vue&type=script&lang=js"
export * from "./BuildSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__